import React, { 
    Component,
    PropTypes,
} from 'react'
import ReactDOM from 'react-dom'
import AreaChart from './area_chart'

class IntroductionChart extends React.Component{
  shouldComponentUpdate(nextProps, nextState) {
    let nextData = nextProps.data.slice(0)
    let data = this.props.data.slice(0)
    return !_.isEqual(nextData.sort(), data.sort())
  }

  constructor(props){
    super(props)
  }

  render() {
    let stageClass = `stage-${this.props.stage}`
    return (
      <div className={`area-chart-wrapper ${stageClass}`}>
        <AreaChart data={this.props.data}/>
      </div>
    )
  }
}

module.exports = IntroductionChart


/** WEBPACK FOOTER **
 ** assets/javascripts/introduction/introduction_chart.js
 **/